import { Link } from 'react-router'
import { RiArrowDownLine } from 'react-icons/ri'
import { ROUTES } from '@/constants/routes'
import servicesImage from '@/assets/images/Services Page.png'

const serviceNav = [
  { number: '01', label: 'Antenatal Empowerment' },
  { number: '02', label: 'Birth Healing Debrief' },
  { number: '03', label: 'Postpartum Home Visits' },
  { number: '04', label: 'Full Birth Journey' },
]

export const ServicesHeroSection = () => (
  <section className="relative bg-surface-dark overflow-hidden py-20 lg:py-32">
    {/* Decorative circles */}
    <div
      aria-hidden="true"
      className="absolute top-0 right-0 w-80 h-80 rounded-full bg-crimson-950 opacity-50 -translate-y-1/3 translate-x-1/3 pointer-events-none"
    />
    <div
      aria-hidden="true"
      className="absolute bottom-0 left-0 w-64 h-64 rounded-full bg-crimson-950 opacity-40 translate-y-1/3 -translate-x-1/4 pointer-events-none"
    />

    {/* Right-side image panel (desktop) */}
    <div className="hidden lg:block absolute top-0 right-0 bottom-0 w-[45%] overflow-hidden pointer-events-none">
      <img
        src={servicesImage}
        alt="A group of expectant mothers in an H.E.R Birth Keeper session"
        className="w-full h-full object-cover object-center brightness-[0.75] saturate-[0.9]"
      />
      {/* Left fade to blend with dark bg */}
      <div className="absolute inset-y-0 left-0 w-40 bg-gradient-to-r from-surface-dark to-transparent" />
      {/* Bottom fade */}
      <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-surface-dark to-transparent" />
    </div>

    {/* Faint H·E·R watermark */}
    <div
      aria-hidden="true"
      className="absolute right-0 bottom-0 font-display font-bold text-white opacity-[0.09] select-none pointer-events-none leading-none hidden lg:block"
      style={{ fontSize: 'clamp(12rem, 22vw, 22rem)', letterSpacing: '-0.06em', lineHeight: 0.85 }}
    >
      H&#xB7;E&#xB7;R
    </div>

    <div className="relative z-10 max-w-[1200px] mx-auto px-6 lg:px-12">
      <div className="max-w-[700px] lg:max-w-[56%]">
        {/* Heading */}
        <h1
          className="font-display font-bold text-white leading-[1.04] mb-6 animate-fade-in-up"
          style={{ fontSize: 'clamp(2.75rem, 6.5vw, 5rem)', animationDelay: '0.2s' }}
        >
          Personalised Support,{' '}
          <em className="text-gold-400 not-italic italic block">Every Step.</em>
        </h1>

        {/* Divider */}
        <div
          className="w-14 h-[3px] rounded-full bg-gradient-to-r from-gold-400 to-crimson-500 mb-7 animate-fade-in"
          style={{ animationDelay: '0.3s' }}
        />

        {/* Description */}
        <p
          className="text-base-300 text-[16px] leading-[1.85] max-w-[560px] mb-10 animate-fade-in-up"
          style={{ animationDelay: '0.35s' }}
        >
          Personalised birth keeper services designed to support, educate, and uplift women and
          families throughout pregnancy and postpartum. Each service is tailored to your unique
          journey, preferences, and needs.
        </p>

        {/* Service navigation pills */}
        <div
          className="flex flex-wrap gap-3 mb-10 animate-fade-in-up"
          style={{ animationDelay: '0.45s' }}
        >
          {serviceNav.map((s) => (
            <span
              key={s.number}
              className="inline-flex items-center gap-2 bg-white/8 border border-white/10 rounded-full px-4 py-2"
            >
              <span className="font-display font-bold text-gold-400 text-sm leading-none">
                {s.number}
              </span>
              <span className="text-[12.5px] text-base-300 font-medium">{s.label}</span>
            </span>
          ))}
        </div>

        {/* CTA */}
        <div
          className="flex flex-wrap items-center gap-4 animate-fade-in-up"
          style={{ animationDelay: '0.55s' }}
        >
          <Link to={ROUTES.ENQUIRY} className="btn-primary">
            Book a Free Support Call
            <RiArrowDownLine size={17} />
          </Link>
        </div>
      </div>
    </div>

    {/* Mobile image */}
    <div className="lg:hidden mt-10 mx-6 rounded-2xl overflow-hidden">
      <img
        src={servicesImage}
        alt="A group of expectant mothers in an H.E.R Birth Keeper session"
        className="w-full h-[220px] object-cover object-center brightness-[0.85]"
      />
    </div>
  </section>
)
